module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_kelly_sm-30c8ae005910f0268d47b3d46d8e68d1.png";